"use client";

import {
  MainVisual,
  News,
  Partners,
  Press,
  ServiceLinks,
} from "@/widgets/app/main";
import MovementMissionSection from "@/widgets/app/page/movement/MovementMissionSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function MainPage() {
  return (
    <SsgoiTransition id="/app/pages/main">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        {/* 1. 메인 비쥬얼 */}
        <MainVisual />
        {/* 2. 메인  서비스 */}
        <ServiceLinks />
        {/* 3. 메인 데이터 정보 */}
        {/* <DataInfo /> */}
        <MovementMissionSection withBackground />
        {/* 4. 언론보도*/}
        <Press />
        <hr className=" mb-20 md:mb-40 border-[#efefef]" />
        {/* 5. 활동소식 */}
        <News />
        {/* 6. 파트너사 */}
        <Partners />
      </div>
    </SsgoiTransition>
  );
}
